const API_URL = process.env.REACT_APP_API_URL ?? "http://localhost:32214/api";
//const API_URL = process.env.REACT_APP_API_URL ?? window.location.origin + "/api";

/** 📸 Obtener todas las fotos de un record */
export async function listPhotos(recordId) {
 
    const res = await fetch(`${API_URL}/BibliotecaFoto/${recordId}`);
  if (!res.ok) throw new Error("Error al obtener las fotos");
  return await res.json();
}

/** 📤 Subir una o varias fotos */
export async function uploadPhotos(recordId, files) {
  const form = new FormData();
  form.append("recordId", recordId);
  for (const file of files) {
    form.append("files", file);
  }

    const res = await fetch(`${API_URL}/BibliotecaFoto/upload`, {
    method: "POST",
    body: form,
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Error al subir archivos");
  }
  return await res.json();
}

/** 🌟 Marcar una foto como portada */
export async function setCover(photoId) {
    const res = await fetch(`${API_URL}/BibliotecaFoto/${photoId}/cover`, {
    method: "POST",
  });

  if (!res.ok) throw new Error("Error al marcar como portada");
  return await res.json();
}

/** 🗑️ Eliminar una foto */
export async function removePhoto(photoId) {
    const res = await fetch(`${API_URL}/BibliotecaFoto/${photoId}`, {
    method: "DELETE",
  });

  if (!res.ok) throw new Error("Error al eliminar la foto");
  return true;
}
